import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButtonsComponent } from '@shared/ui/app-buttons/app-buttons';
import { BUTTON_CLASS_TYPES } from '../../constants/app-button.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { ROUTES } from '@shared/constants/routes';
import { ROLES } from '@constants/role.constants';
import { AuthService } from '@shared/services/auth.service';
import { ProfileService } from '@shared/services/profile.service';

@Component({
  selector: 'app-header',
  imports: [TranslatePipe, AppButtonsComponent],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
})
export class Header {
  protected readonly BUTTON_CLASS_TYPES = BUTTON_CLASS_TYPES;
  menuOpen = false;
  ROUTES = ROUTES;
  selectedRoute = signal(ROUTES.HOME);

  private readonly router = inject(Router);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly http = inject(HttpClient);
  private readonly authService = inject(AuthService);
  private readonly route = inject(ActivatedRoute);
  private readonly profileService = inject(ProfileService);

  readonly user = this.authService.user;
  readonly role = computed(() => this.authService.getRole());
  readonly getProfileImageUrl = this.profileService.getProfileImageUrl(this.authService.getRole() ?? ROLES.CANDIDATE);

  private readonly svgResource = rxResource<string, unknown>({
    stream: () => this.http.get('assets/image/grens-find.svg', { responseType: 'text' })
  });

  readonly svgContent = computed<SafeHtml | null>(() => {
    const svg = this.svgResource.value();
    if (!svg) return null;
    const svgWithClass = svg.replace('<svg', '<svg class="header-svg" style="width:139px;height:49px;"');
    return this.sanitizer.bypassSecurityTrustHtml(svgWithClass);
  });

  constructor() {
    const currentRoute = this.router.url
      .replace(ROUTES.CANDIDATE_LOGGED_HOME, '')
      .replace(ROUTES.EMPLOYER_LOGGED_HOME, '')
      .split('/');
    if (currentRoute.length > 0) {
      this.selectedRoute.set(currentRoute?.at(-1) ?? ROUTES.HOME);
    }
  }

  showAlert(text: string) {
  }

  onSubmit(): void {
  }

  goTo(path: string) {
    this.router.navigateByUrl(`/${path}`);
  }

  getLinkHome() {
    if (this.authService.isLoggedIn()) {
      return this.user()?.user?.role === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    }
    return ROUTES.HOME;
  }

  onAdd() {
    this.router.navigate([ROUTES.CREATE_OPPORTUNITY], { relativeTo: this.route });
  }

  onClickProfile() {
    this.router.navigate([ROUTES.PROFILE], { relativeTo: this.route });
  }

  onClickHome() {
    this.selectedRoute.set(ROUTES.HOME);
    this.router.navigate([this.getLinkHome()]);
  }

  onYourAds() {
    this.selectedRoute.set(ROUTES.YOURS_OPPORTUNITIES);
    this.router.navigate([ROUTES.YOURS_OPPORTUNITIES], { relativeTo: this.route });
  }

  getBtnClassSelected(expectedUrl: string) {
    if (this.selectedRoute() === expectedUrl) {
      return BUTTON_CLASS_TYPES.PRIMARY;
    }
    return BUTTON_CLASS_TYPES.TERTIARY;
  }

  onClickMessages() {
    this.selectedRoute.set(ROUTES.MESSAGES);
    const basePath =
      this.user()?.user?.role === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    this.router.navigate([basePath, ROUTES.MESSAGES]);
  }

  onClickDashboard() {
    this.selectedRoute.set(ROUTES.DASHBOARD);
    const basePath =
      this.role() === ROLES.EMPLOYER
        ? ROUTES.EMPLOYER_LOGGED_HOME
        : ROUTES.CANDIDATE_LOGGED_HOME;
    
    this.router.navigate([basePath, ROUTES.DASHBOARD]);
  }
}
